import { ThemeUICSSObject, spacing } from '@apia/theme';

const directories: ThemeUICSSObject = {
  '.directory__wrapper': {
    '&.selected': {
      '& > .collapsiblePanel > .collapsiblePanel__label': {
        fontWeight: '900',
        background: 'primary',
        color: 'white',
        width: '100%',
      },
    },

    '.directory__content': {
      pl: spacing(5),
      borderLeft: '1px solid',
      borderColor: 'transparent',
      transition: 'border-color 0.3s',
    },
  },
  '&:hover': {
    '.directory__wrapper': {
      '.directory__content': {
        borderColor: 'muted',
      },
    },
  },
};

export default directories;
